let checkoutUrl = "https://redcarpetmanicure.co.uk/cart/checkout";

/**@param {import("$lib/types").MagentoCustomer | ??}customer */
export const klaviyoIdentify = (customer) => {
   if (customer) {
      if (window?._learnq?.identify !== undefined) {
         window?._learnq?.identify({
            "$email": customer.customer.email,
            "$first_name": customer.customer.firstname,
            "$last_name": customer.customer.lastname,
         });
      }
   }
}


/**@param {import("$lib/types").PublicProduct} product */
export const klaviyoViewItem = (product) => {
   if (window?._learnq?.identify !== undefined) {
      let item = {
         "ProductName": product.name,
         "ProductID": product.id,
         "SKU": product.sku,
         "Categories": "",
         "ImageURL": product.images.image,
         "URL": product.url,
         "Brand": "",
         "Price": product.specialPrice ? product.specialPrice : product.price,
         "CompareAtPrice": product.price
      };

      window?._learnq.push(["track", "Viewed Product", item]);
   }
}
/**
 * @param {import("$lib/types").PublicProduct}product 
 * @param {import('$lib/types').MagentoCart} cart
 * @param {import('$lib/types').MagentoCartTotals} cartTotals
 * */
export const klaviyoAddToCart = (cartTotals, cart, product) => {
   if (window?._learnq?.identify !== undefined) {
      window?._learnq.push(["track", "Added to Cart", {
         "$value": cartTotals.grand_total,
         "AddedItemProductName": product.name,
         "AddedItemProductID": String(product.id),
         "AddedItemSKU": product.sku,
         "AddedItemCategories": [""],
         "AddedItemImageURL": product.images.image,
         "AddedItemURL": product.url,
         "AddedItemPrice": product.specialPrice ? product.specialPrice : product.price,
         "AddedItemQuantity": 1,
         "ItemNames": product.name,
         "CheckoutURL": checkoutUrl,
         "Items": cart.items,
      }]);
   }
}
/**
 *  @param {import('$lib/types').MagentoCart} cart
 * @param {import('$lib/types').MagentoCartTotals} cartTotals
  */
export const klaviyoStartCheckout = (cart, cartTotals) => {
   if (window?._learnq?.identify !== undefined) {
      window?._learnq.push(["track", "Started Checkout", {
         "$event_id": cart.id,
         "$value": cartTotals.grand_total,
         "ItemNames": cart.items.filter(item => item.name),
         "CheckoutURL": checkoutUrl,
         "Categories": [""],
         "Items": cart.items
      }]);
   }
}

/**
 *  @param {import('$lib/types').MagentoCartItem} product
 * */
export const klaviyoDeleteProduct = (product, quantity = 1) => {
   if (window?._learnq?.identify !== undefined) {
      window._learnq?.push(['track', "Delete product from Cart", {
         ProductID: product.item_id,
         Name: product.name,
         price: product.price,
         Quantity: quantity
      }]);

   }
}